import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { getHotelReviewSourceLogo } from '../../../../../utils/reviews';
import {
    HotelReviewSourceType,
    HOTEL_REVIEWS_SOURCES_LIST }
  from '../../../../../models/hotel-reviews';
import { TagCheckbox } from '../TagCheckbox';
import S from '../../../../../stores';

export interface SourceFilterProps {
    sources: HotelReviewSourceType[];
}

interface StyledSourceFilterProps extends JSSClassesProps<ComponentJSSClasses>, SourceFilterProps {}

export const SourceFilter = observer((props: StyledSourceFilterProps) => {
    const { classes, sources } = props;

    const isChecked = (source: number): boolean =>
        S.hotelReviews.sourcesFilter.includes(source);

    const handleChange = (source: number) => {
        S.hotelReviews.setSourcesFilter(source);
    };

    const renderCheckbox = (source: number) => {
        const sourceName = HOTEL_REVIEWS_SOURCES_LIST[source];
        const logoStyleClass = `tag${sourceName}Logo`;
        const wrapperClass = `tag${sourceName}`;

        return (
            <TagCheckbox
                label={sourceName}
                checked={isChecked(source)}
                onChange={() => handleChange(source)}
                // @ts-ignore
                wrapperClassNames={classes[wrapperClass]}
                innerClassName={classes.tagImage}
            >
                <img
                    // @ts-ignore
                    className={classes[logoStyleClass]}
                    src={getHotelReviewSourceLogo(source)}
                    alt={sourceName}
                />
            </TagCheckbox>
        );
    };

    return (
        <div className={classes.container}>
            {sources.map((source, id) => (
                <React.Fragment key={`source_${source}_${id}`}>
                    {renderCheckbox(source)}
                </React.Fragment>
            ))}
        </div>
    );
});
